// Session-scoped tracker of question IDs whose quality_warning was just cleared
// (typically via Auto Rejudge After Bulk). Used to render a green "just fixed"
// badge that resets on tab close.
const KEY = "justFixedQids_v1";

function _read() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? new Set(JSON.parse(raw)) : new Set();
  } catch { return new Set(); }
}

function _write(set) {
  try { sessionStorage.setItem(KEY, JSON.stringify([...set])); } catch { /* ignore */ }
}

export function addJustFixed(qid) {
  if (!qid) return;
  const s = _read();
  s.add(qid);
  _write(s);
}

export function isJustFixed(qid) {
  return _read().has(qid);
}

export function clearJustFixed() {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
